import * as turf from "@turf/turf";
import * as moment from "moment";

export const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export const generateVertexes = (point1, point2) => {
  const line = turf.lineString([point1, point2]);
  const bbox = turf.bbox(line);
  return [
    [bbox[0], bbox[1]],
    [bbox[0], bbox[3]],
    [bbox[2], bbox[3]],
    [bbox[2], bbox[1]],
  ];
};

export const center = (points) => {
  if (!points) return null;
  const feature = turf.points(points);
  return turf.center(feature);
};

export const generateDays = (startDate, endDate) => {
  const results = [];
  var start = startDate ? moment(startDate, "YYYY-MM-DD") : moment();
  var end = endDate ? moment(endDate, "YYYY-MM-DD") : moment();
  const startWeekday = start.weekday();
  const endWeekday = end.weekday();
  const startBlankDays = Array(startWeekday).fill(null);
  const endBlankDays = Array(7 - endWeekday - 1).fill(null);
  results.push(...startBlankDays);
  results.push(start.format("YYYY-MM-DD"));
  while (start.add(1, "days").isBefore(end)) {
    results.push(start.format("YYYY-MM-DD"));
  }
  results.push(end.format("YYYY-MM-DD"));
  results.push(...endBlankDays);
  return results;
};

export const generateMonths = (dates) => {
  return dates.reduce((accumulator, date, index) => {
    if (!date) return accumulator;
    const lastIndex = date.lastIndexOf("-01");
    if (lastIndex === 7) {
      const m = moment(date, "YYYY-MM-DD").format("MMM");
      return [
        ...accumulator,
        {
          name: m,
          column: Math.ceil(index / 7),
        },
      ];
    }
    return accumulator;
  }, []);
};
